module.exports = __webpack_public_path__ + "static/media/02-1.07fb7f88.png";